/**
 * Tiny helper that builds the `?from=…` portion of a Firm 360 link so the
 * back button returns to the exact URL (filters and all) the user left.
 *
 * Use:
 *   navigate(`/firms/${sub}${firmFromQS(location)}`);
 *
 * The `from` value is URL-encoded so the embedded `?` and `&` survive a round
 * trip through the address bar. Firm360 decodes and navigates to the exact
 * URL on Back. Sidebar links remain unaffected — they don't pass `from`, so
 * clicking "Dashboard" in the sidebar always opens a fresh, unfiltered view.
 */
export function firmFromQS(location) {
  const here = `${location.pathname || ""}${location.search || ""}`;
  // No filters and no special context — fall back to bare path for cleaner URLs.
  if (!location.search) {
    return `?from=${encodeURIComponent(location.pathname || "/dashboard")}`;
  }
  return `?from=${encodeURIComponent(here)}`;
}
